import Box from '@mui/material/Box';

const RequiredMark = ({ sx = {} }) => {
   return (
      <Box
         component="span"
         aria-hidden="true"
         sx={{
            color: '#E34935',
            fontSize: '14px',
            lineHeight: 1,
            ...sx,
         }}
      >
         *
      </Box>
   );
}

export default RequiredMark;